import { AppState } from "shared/datamodel/schemas/app-state";
import { DispatchEvent, useStateValue as untypedUseStateValue } from ".";

export default function useStateValue(): [AppState, (e: DispatchEvent) => void] {
  const stateValue = untypedUseStateValue() as any;
  return stateValue;
}
